var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "viewer"
  }, [_c('iframe', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": _vm.pdfUrl,
      "width": _vm.width,
      "height": _vm.height
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };